import { atom } from "recoil";

import { keysOfRecoil } from "store/recoil/keys";

export const currentCenterModalState = atom<boolean>({
  key: keysOfRecoil.modal.center,
  default: false,
});
